import React from 'react'
import {useLocation, Navigate} from 'react-router-dom'
import PropTypes from 'prop-types'
import {trackLocationChange} from '#services/tracking'
import {defaultPathForRole} from '#helpers/defaultPathForRole'
import useUserModuleSettings from '#hooks/useUserModuleSettings'
import {getUser} from '#services/storage'

const userIsLoggedIn = () => getUser() !== null
const userHasRole = (requiredRole, currentRole) => !requiredRole || requiredRole.includes(currentRole)

function PrivateRoute({requiredRole, path, currentUserRole, children}) {
  const location = useLocation()

  if (!userIsLoggedIn()) {
    return <Navigate to={{pathname: '/login', state: {from: location}}} />
  }

  const {showModule, isModulePath, moduleSettingsLoading} = useUserModuleSettings()
  const moduleIsActivated = isModulePath(path) ? showModule(path) : true

  if (moduleSettingsLoading === false && (!userHasRole(requiredRole, currentUserRole) || !moduleIsActivated)) {
    const defaultPath = defaultPathForRole(currentUserRole)
    return <Navigate to={{pathname: defaultPath, state: {from: location}}} />
  }
  trackLocationChange(location.pathname.toLowerCase(), currentUserRole)
  return children
}

export default PrivateRoute

PrivateRoute.propTypes = {
  requiredRole: PropTypes.array,
  path: PropTypes.string,
  currentUserRole: PropTypes.string,
}
